<div class="properties-row">
    <app-widget-agent-select [items]="agents$|async" bindLabel="name" [model]="gridItem.setup.agentIds" bindValue="userId" title="{{ 'dashboard:Select Agents' | i18next }}"
                             (modelChange)="gridItem.setup.agentIds=$event" (modelChange)="modelChange()" [gridItem]="gridItem">
    </app-widget-agent-select>

    <app-widget-select [items]="agentProperties$|async" bindLabel="name" [model]="gridItem.setup.agentPropertiesIds" title="{{ 'dashboard:Select Agent Columns' | i18next }}"
                       bindValue="id" (modelChange)="gridItem.setup.agentPropertiesIds=$event" (modelChange)="modelChange()" [translateItems]="true">
    </app-widget-select>

    <app-widget-type-select [widgetType]="gridItem.type" (modelChange)="gridItem.type=$event" title="{{ 'dashboard:Visual Type' | i18next }}"
                            (modelChange)="modelChange()" [disabledItems]="visualTypedisabledItems">
    </app-widget-type-select>
</div>
<div class="properties-row sort-row" *ngIf="isSortingVisible">
  <label>{{ 'dashboard:Row sorting' | i18next }}</label><br /><br />
  <app-manual-row-sort [items]="manualRowOrderItems" [gridItem]="gridItem" bindLabel="name" bindValue="userId"></app-manual-row-sort>  
  <div *ngIf="!isManualRowOrderEnabled">
    <app-sort-select [properties]="agentProperties" [gridItem]="gridItem" [items]="gridItem.setup.agentPropertiesIds"></app-sort-select><br />  
    <app-sort-select *ngIf="isSecondLevelSortingEnabled" [properties]="agentProperties" [gridItem]="gridItem" [items]="gridItem.setup.agentPropertiesIds" [isSecondSorting]="true"></app-sort-select>
  </div>
</div>
